/**
 * @generated SignedSource<<41000fc5382f12ce8496fe7901b96f37>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useUpdateReactionInCacheFragment$data = {
  readonly ari: string;
  readonly containerAri: string;
  readonly reactionsCount: number;
  readonly reactionsSummaryForEmoji: ReadonlyArray<{
    readonly __typename: "ReactionsSummaryForEmoji";
    readonly count: number;
    readonly emojiId: string;
    readonly id: string;
    readonly reacted: boolean;
  } | null | undefined>;
  readonly " $fragmentType": "useUpdateReactionInCacheFragment";
};
export type useUpdateReactionInCacheFragment$key = {
  readonly " $data"?: useUpdateReactionInCacheFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateReactionInCacheFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useUpdateReactionInCacheFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        },
        {
          "kind": "ScalarField",
          "name": "__typename"
        }
      ]
    }
  ],
  "type": "ReactionsSummaryResponse"
};

(node as any).hash = "94bb7aa669a3f8af9f245251eef1cc84";

export default node;
